module.exports = {"showMore":"Show all","showLess":"Show less","more":"and one more | and {amount} more"}